// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

export function cookChecklistCreate(params: {
  ingredient_id: number
  checked: boolean
  recipe_id: number
}) {
  return http<{
    ingredient_id: number
    checked: boolean
  }>({
    url: "/api/v1/cook-checklist/{recipe_id}/",
    method: "post",
    params,
    pathParamNames: ["recipe_id"],
  })
}
